// extracted by mini-css-extract-plugin
export default {"twoFaInput":"two-fa-input_twoFaInput__dxs+X","error":"two-fa-input_error__P8NZz","opacity-transition":"two-fa-input_opacity-transition__jyp1t"};